import { API_RESPONSE } from 'eva-fe-sdk-types';
import CrudConsumer from './index';
import { SDKRequestInit } from '../lib/ApiFetch';
import Endpoint from '../lib/Endpoint';

class Jackpot extends CrudConsumer {
  get = (config: SDKRequestInit) => {
    const url: string = Endpoint.getJackpots(this.productType);
    return this.apiFetch.get<API_RESPONSE.Jackpot['200']>(url, config);
  };
}

export default Jackpot;
